var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('label',{staticClass:"bcx-checkable-input bcx-checkable-input--radio"},[_c('input',_vm._b({ref:"input",attrs:{"type":"radio"},domProps:{"checked":_vm.selected===_vm.$attrs['value']},on:{"change":_vm.onChange}},'input',_vm.$attrs,false)),_c('span',[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }